import React, { useEffect, useState } from "react";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
// import deleteimg from '../../assets/images/delete-icon.png';
import "../../assets/styles/deletePopup.css";
import { getOrderDetailsByOrderId } from "../../reducers/adminReducers";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../loader/loader";
const ConfirmationPopUp = ({
  title,
  onCloseModal,
  open,
  handleConfirm,
  id,
  displayName,
  handleReason,
  handleTrackOrderId,
  payload,
}) => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const result = useSelector((state) => state.admin);
  const { orderDetails } = result || {};

  useEffect(() => {
    if (!id) {
      return;
    }
    const getOrderDetailsByIdAsync = async () => {
      setLoader(true);
      await dispatch(getOrderDetailsByOrderId(id));
      setLoader(false);
    };
    getOrderDetailsByIdAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <Modal
          className="delete-modal-dialog order-process-popup"
          isOpen={open}
          toggle={onCloseModal}
          style={{ overlay: { opacity: 0.1 } }}
          centered>
          <ModalHeader
            onClick={onCloseModal}
            className="delete-modal-header"
            toggle={onCloseModal}></ModalHeader>
          <ModalBody>
            <h3>
              {title}
              <br />
            </h3>
            <div className="admin-input">
              {displayName === "cancel" && (
                <div className="desc">
                  <Label className="col-form-label pt-0">Reason</Label>
                  <textarea
                    onChange={handleReason}
                    className="form-control"
                    type="text"
                    name="reason"
                  />
                </div>
              )}

              {displayName === "shipped" && (
                <>
                  {orderDetails && orderDetails.length > 0 && (
                    <table className="table table table-bordered mt-3">
                      <thead>
                        <tr>
                          <td>S.No</td>
                          <th>Item</th>
                          <th>Price</th>
                          <th>Track Order Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderDetails.map((elem, index) => (
                          <tr key={index}>
                            <td className="text-danger">{index + 1}</td>
                            <td className="text-danger">
                              {elem?.productId?.name}
                            </td>
                            <td className="text-danger">{elem?.price}</td>
                            <td>
                              <input
                                onChange={(e) => handleTrackOrderId(e, elem)}
                                className="form-control"
                                type="text"
                                name="trackOrderNumber"
                                value={
                                  payload?.trackOrderNumber?.find(
                                    (x) => x.id === elem._id
                                  )?.trackNumber || ""
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="primary"
              className="delete-button"
              style={{ background: "#ff4d53 !important" }}
              onClick={() => handleConfirm(id)}>
              Confirm
            </Button>
            <Button
              type="button"
              color="secondary"
              className="cancel-button"
              onClick={onCloseModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};
export default ConfirmationPopUp;
